import React from 'react';
import { Icon } from 'antd';
const SelectedFilters = ({ resetFilters, activeFiltersCount }) => {

  return (
    <div className="filtersInfoPanel">
      {!activeFiltersCount ? (
        <div>Выбрано фильтров: 0</div>
      ) : (
        <div className="btnGroup">
          <span className="filtersInfoBadge">
            <Icon
              style={{ fill: '#00a8ff' }}
              type="info-circle"
              theme="filled"
            />
            Выбрано фильтров:{' '}
            {activeFiltersCount !== null ? activeFiltersCount : 0}
          </span>
          <span className="resetFilters" onClick={resetFilters}>
            Сбросить
          </span>
        </div>
      )}
    </div>
  );
};

export default SelectedFilters;
